import { Types } from './types'

const initialState = {
    dataCategory: {
        filter: {},
        rows: []
    },
    currentRecord: null
}
const homeReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_CATEGORY:
            return {
                ...newState,
                dataCategory: action.payload
            }
        case Types.SET_RECORD:
            return {
                ...newState,
                currentRecord: action.payload
            }
        default:
            return { ...newState }
    }
}
export default homeReducer
